import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { Query } from 'react-apollo';
import { get } from 'lodash-es';
import { GetUsersQuery } from '../../../operations/queries/GetUsersQuery';
import { handleRequestError } from '../../../constants/errorCodes';
import { FormattedMessage } from 'react-intl';
import { USER_ACCOUNT_BUSINESS } from '../../../constants/userDefs';
import { UsersTable } from './UsersTable';
import { UserTransactionsTable } from './TransactionsTable';
import { useQuery } from 'react-apollo';
import { GetCurrencyConfigQuery } from '../../../operations/queries/GetCurrencyConfigQuery';
import { useEffect } from 'react';
import { currencyDisplayUpdate } from '../../../components/CurrencyDisplay';

const AdminDashboard = () => {
  const take = 15;
  const IS_EMPLOYEE = false;
  const dispatch = useDispatch();

  const { data, /* loading, error  */} = useQuery(GetCurrencyConfigQuery, {
    variables: { configId: 1 },
    onError: error => handleRequestError(error, dispatch),
  });

  let appCurrencyConfiguration = {
    defaultCurrency: null,
    dualCurrencyDisplay: null
  };

  if(data !== undefined && data !== null){
     appCurrencyConfiguration = data.getCurrencyConfig;
  }

  useEffect(() => {
    dispatch({
      type: 'SET_CURRENCY_CONFIG',
      defaultCurrency: appCurrencyConfiguration.defaultCurrency,
      dualCurrencyDisplay: appCurrencyConfiguration.dualCurrencyDisplay
    });
  },[
    appCurrencyConfiguration.defaultCurrency,
    appCurrencyConfiguration.dualCurrencyDisplay,
    dispatch
  ]);

  const currencyDataConfig = useSelector(state => state.currencyConfig);
  if(currencyDataConfig.dualCurrencyDisplay !== null){
    currencyDisplayUpdate(currencyDataConfig.defaultCurrency);
  }


  const USER_FULL_NAME_COLUMN = {
    className: 'react-table-cells d-flex align-items-center',
    minWidth: 150,
    Cell: rowInfo => {
      if (rowInfo.original.sector === USER_ACCOUNT_BUSINESS) {
        return rowInfo.original.businessName || `<${rowInfo.original.email}> [${rowInfo.original.id}]`;
      }
      return (
        `${rowInfo.original.firstName ? rowInfo.original.firstName : ''} ${
          rowInfo.original.lastName ? rowInfo.original.lastName : ''
        }`.trim() || `<${rowInfo.original.email}> [${rowInfo.original.id}]`
      );
    },
  };

  const USER_SECTOR_COLUMN = {
    className: 'react-table-cells d-flex align-items-center',
    minWidth: 120,
    id: 'sector',
    accessor: 'sector',
    Cell: rowInfo => (
      <div>
        {rowInfo.original.sector && <FormattedMessage id={`adminUsersListPage.filter.${rowInfo.original.sector}`} />}
      </div>
    ),
  };

  const newUsersColumns = [USER_FULL_NAME_COLUMN, USER_SECTOR_COLUMN];

  return (
    <Container fluid>
      <Row className="no-gutters mt-3">
        <Col>
          <Row className="mb-5">
            <Col xs="12" md="6">
              <Query
                query={GetUsersQuery}
                variables={{
                  filter: { isEmployee: IS_EMPLOYEE },
                  order: { createdAt: 'DESC' },
                  skip: 0,
                  take: take,
                }}
                onError={error => handleRequestError(error, dispatch)}
                fetchPolicy="network-only"
                notifyOnNetworkStatusChange={true}
              >
                {({ data: newUsersData, loading: newUsersLoading, refetch: refetchNew, fetchMore: fetchMoreNew }) => {
                  const newUsers = get(newUsersData, 'getUsers.users', []);
                  const newQueryCount = get(newUsersData, 'getUsers.queryCount', 0);
                  return (
                    <UsersTable
                      titleId="adminDashboard.newUsers"
                      columns={newUsersColumns}
                      data={newUsers}
                      loading={newUsersLoading}
                      refetch={refetchNew}
                      filter={{ isEmployee: IS_EMPLOYEE }}
                      fetchMore={fetchMoreNew}
                      take={take}
                      queryCount={newQueryCount}
                    />
                  );
                }}
              </Query>
            </Col>
            <Col xs="12" md="6">
              <Query
                query={GetUsersQuery}
                variables={{
                  filter: { isEmployee: IS_EMPLOYEE, verified: false },
                  order: { createdAt: 'DESC' },
                  skip: 0,
                  take: take,
                }}
                onError={error => handleRequestError(error, dispatch)}
                fetchPolicy="network-only"
                notifyOnNetworkStatusChange={true}
              >
                {({
                  data: unverifiedUsersData,
                  loading: unverifiedUsersLoading,
                  refetch: refetchUnverified,
                  fetchMore: fetchMoreUnverified,
                }) => {
                  const unverifiedUsers = get(unverifiedUsersData, 'getUsers.users', []);
                  const unverifiedQueryCount = get(unverifiedUsersData, 'getUsers.queryCount', 0);

                  return (
                    <UsersTable
                      titleId="adminDashboard.unverifiedUsers"
                      columns={newUsersColumns}
                      data={unverifiedUsers}
                      loading={unverifiedUsersLoading}
                      refetch={refetchUnverified}
                      filter={{ isEmployee: IS_EMPLOYEE, verified: false }}
                      fetchMore={fetchMoreUnverified}
                      take={take}
                      queryCount={unverifiedQueryCount}
                    />
                  );
                }}
              </Query>
            </Col>
          </Row>
          <Row>
            <Col>
              <UserTransactionsTable />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
